function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { shallowMemoize } from "@sail/utils";
// Please keep this in sync with the list of directives in annotateWithDirectives.js
const directivesToRemove = [
    'tag',
    'hash'
];
export default shallowMemoize((query)=>{
    const output = {};
    const gql = _object_spread_props(_object_spread({}, query), {
        definitions: query.definitions.map((definition)=>{
            if (!('directives' in definition) || !definition.directives) {
                return definition;
            }
            return _object_spread_props(_object_spread({}, definition), {
                directives: definition.directives.filter((node)=>{
                    const isRelevantDirective = isInArray(directivesToRemove, node.name.value);
                    if (isRelevantDirective) {
                        var _node_arguments;
                        const id = (_node_arguments = node.arguments) === null || _node_arguments === void 0 ? void 0 : _node_arguments.find(({ name })=>name.value === 'id');
                        if (id && id.value.kind === 'StringValue') {
                            output[node.name.value] = id.value.value;
                        }
                        return false;
                    }
                    return true;
                })
            });
        })
    });
    return {
        gql,
        directives: output
    };
});
function isInArray(array, value) {
    return array.includes(value);
}

//# sourceMappingURL=removeDirectives.js.map